"use client";

import React from "react";
import { Activity, Award, ChartBar as BarChart3, Layers } from 'lucide-react';
import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
interface Differentiator {
  title: string;
  description: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
const differentiators: Differentiator[] = [{
  title: "Physiotherapy",
  description: "Musculoskeletal assessment, treatment and rehabilitation from appropriately registered professionals",
  icon: Activity
}, {
  title: "Specialist Biomechanics",
  description: "Biomechanical expertise led by Dr Andrew Greenhalgh, PhD in Biomechanics",
  icon: Award
}, {
  title: "Objective Movement Data",
  description: "Pressure-mat gait and balance analysis available where useful",
  icon: BarChart3
}, {
  title: "Integrated Services",
  description: "Physiotherapy, massage, biomechanics and orthotics available within one service, delivered in partnership with Physiogenics",
  icon: Layers
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut"
    }
  }
};
export default function WhyChooseUs() {
  return <section id="whychooseusbatchwood" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-b border-border/60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-3xl mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-foreground">
            Why Choose PhysAnalytica at Batchwood?
          </h2>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }}>
          {differentiators.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={item.title} data-index={i} variants={cardVariants} className="h-full">
                <Card className="h-full border border-border bg-card text-card-foreground shadow-xs hover:shadow-md transition-all duration-200 hover:-translate-y-1 flex flex-col justify-between p-6">
                  <div>
                    <CardHeader className="p-0 mb-5">
                      <div className="w-12 h-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4">
                        <Icon className="size-6 stroke-[1.75]" />
                      </div>
                      <CardTitle className="text-lg font-semibold tracking-tight text-foreground">
                        {item.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="p-0">
                      <p className="text-sm leading-relaxed text-muted-foreground">
                        {item.description}
                      </p>
                    </CardContent>
                  </div>
                </Card>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}